/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.BOND.Title',
    defaultMessage: 'BOND',
  },
});

export default messages;
